<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let showModal = false;
	export let withBlur = false;
	export let withoutCancel = false;
	export let autoClose = true;
	export let classes = '';
	export let contentClasses = '';
	let dialog: HTMLDialogElement | null = null; // HTMLDialogElement

	const dispatch = createEventDispatcher();

	$: if (dialog && showModal) dialog.showModal();
	$: if (dialog && !showModal) dialog.close();

	function closeModal() {
		if (withoutCancel) return;
		dialog?.close();
		showModal = false;
		dispatch('close-modal');
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<dialog
	bind:this={dialog}
	on:close={closeModal}
	on:click|self={() => {
		if (autoClose) {
			closeModal();
		}
	}}
	class={`relative flex flex-col rounded-2xl border-none bg-white px-8 py-6 shadow-2xl ${classes}`}
	class:is-blur={withBlur}
	class:hidden={!showModal}
>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div on:click|stopPropagation class={`flex flex-1 flex-col ${contentClasses}`}>
		<slot />
		{#if !withoutCancel}
			<button
				translate="no"
				class="material-icons-round absolute right-8 top-8 z-20 text-2xl text-grey-700 hover:text-grey-900"
				on:click={closeModal}>close</button
			>
		{/if}
	</div>
</dialog>

<style>
	dialog {
		overflow: inherit;
	}
	dialog::backdrop {
		background: rgba(0, 0, 0, 0.3);
	}

	dialog.is-blur::backdrop {
		backdrop-filter: blur(4px);
	}

	dialog:focus-visible {
		outline: none;
	}

	dialog[open] {
		animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
	}
	@keyframes zoom {
		from {
			transform: scale(0.95);
		}
		to {
			transform: scale(1);
		}
	}
	dialog[open]::backdrop {
		animation: fade 0.2s ease-out;
	}
	@keyframes fade {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
